const types = {
  SET_PASSO_ATUAL: 'SET_PASSO_ATUAL',
  SET_LISTA_UNIDADES: 'SET_LISTA_UNIDADES',
  SET_UNIDADE: 'SET_UNIDADE',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_DOCUMENTO: 'SET_DOCUMENTO',
  SET_NUMERO_DOCUMENTO: 'SET_NUMERO_DOCUMENTO',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
}

export default types
